export class ModeleArticleAnnee {
    static jsonMap = {
        idModeleArticle: 'idModeleArticle',
        idRefCampagne: 'idRefCampagne'
    };

    idModeleArticle: number;
    idRefCampagne: number;
}
